<template>
  <div>
    <div class="text-xs-right">
      <v-btn small outline color="primary" flat class="ma-0" @click="convertImageRatio">
        <span class="material-icons mr-2">
          {{ ratio == 'square' ? 'crop_16_9' : 'crop_square' }}</span
        >
        {{ $t(`Resize to ${ratio == 'square' ? 'Horizontal' : 'Square'}`) }}
      </v-btn>
    </div>
    <div
      style="overflow-x: auto; overflow-y: hidden; margin-bottom: 5px; margin-top: 15px"
      v-if="generics"
    >
      <div
        style="display: flex; margin: 0; align-items: stretch; padding-bottom: 25px"
        :style="{ width: generics.length * 315 + (generics.length < 10 ? 315 : 0) + 'px' }"
      >
        <div
          style="width: 300px; margin-right: 15px"
          v-for="(generic, index) in generics"
          :key="'generic_' + index"
        >
          <generic-manage
            :vkey="index"
            v-model="generics[index]"
            @onDelete="onDeleteGeneric(index)"
            :ratio="ratio"
          >
            <move-horizontal
              slot="move"
              :index="index"
              :max="generics.length"
              @onMove="onMove(index, $event)"
              style="display: inline-block;"
            ></move-horizontal>
          </generic-manage>
        </div>

        <div
          v-if="generics.length < 10"
          @click="addGeneric"
          style="
          position: relative;

          width: 300px;
          border: 4px dashed #eee;
          border-radius: 20px;
          cursor: pointer;
        "
          :style="{ 'min-height': ratio == 'horizontal' ? '157px' : '300px' }"
        >
          <div
            style="
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -10px;
            margin-top: -23px;
            font-size: 32px;
          "
          >
            <span class="fa fa-plus"></span>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import GenericManage from '@/components/elements/GenericManage'
import MoveHorizontal from '@/components/elements/MoveHorizontal'

export default {
  props: {
    value: {
      default: undefined
    },
    ratio: { default: 'square' }
  },
  components: {
    GenericManage,
    MoveHorizontal
  },
  data: function() {
    return {
      generics: undefined
    }
  },
  mounted: function() {
    this.generics = this.value
  },
  methods: {
    convertImageRatio() {
      this.$emit('changeRatio', this.ratio == 'horizontal' ? 'square' : 'horizontal')
    },
    onDeleteGeneric(index) {
      if (this.generics.length == 1) {
        this.$emit('deleteMessage')
      } else {
        this.generics.splice(index, 1)
      }
    },
    onMove: function(index, direction) {
      var vm = this
      if (direction == 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction == 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    addGeneric: function() {
      this.generics.push({
        image_url: null,
        title: '',
        subtitle: '',
        buttons: []
        // default_action: {
        //   type: 'web_url',
        //   url: '',
        // },
      })
    }
  },
  watch: {
    value: function(newVal) {
      this.generics = newVal
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentGenericManage.vue